<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">Trạng thái</label>
                <v-select v-model="selectedStatusValue" :options="statusOptions" name="status" :clearable="false"
                          :reduce="item => item.value">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                   @update="dateRangePicker" v-model="dateRange" class="w-full">
                </date-range-picker>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 w-1/2 lg:mt-4 sm:mt-2 mt-4">
                <vs-button class="lg:mt-4 sm:mt-6" color="primary" iconPack="feather" icon="icon-search"
                           @click="filter">Tìm kiếm
                </vs-button>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="paraclinicalExamData" :animateRows="true" :pagination="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :onGridReady="onGridReady" :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="paraclinicalExamData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    paraclinicalExamData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : paraclinicalExamData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererActionsExam from "./cell-renderer/CellRendererActionsExam";
import CellRendererCustomerStatus from "./cell-renderer/CellRendererCustomerStatus";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererStatus,
        CellRendererActionsExam,
        CellRendererCustomerStatus,
    },

    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
        type: {
            default: null,
            type: Number,
        },
        statusOptions: {
            type: Array,
        },
        beautyMedicalRecordId: {
            default: null,
            type: Number,
        }
    },

    data() {
        return {
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Ngày thực hiện',
                    field: 'hospitalAdmissionDateStr',
                    minWidth: 150,
                },
                {
                    headerName: 'Mã phiếu',
                    field: 'beautySubclinicalNanoCode',
                    minWidth: 280,
                },
                {
                    headerName: 'Nhóm dịch vụ',
                    field: 'beautySubclinicalNameDetails',
                    minWidth: 100,
                },
                {
                    headerName: 'Dịch vụ',
                    field: 'beautyServiceName',
                    minWidth: 150,
                },
                {
                    headerName: 'Yêu cầu',
                    field: 'request',
                    minWidth: 150,
                },
                {
                    headerName: 'Trạng thái',
                    field: 'status',
                    minWidth: 150,
                    cellRendererFramework: 'CellRendererStatus',
                    suppressSizeToFit: true,
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActionsExam',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            dateRange: {
                // endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                // startDate: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0,0,0,0),
                endDate: null,
                startDate: null,
            },
            customerTypeOptions: [
                {value: null, label: "Tất cả"},
                {value: 1, label: "Khách hàng cũ tới tái khám"},
                {value: 2, label: "Khách hàng cũ sử dụng dịch vụ"},
                {value: 3, label: "Khách hàng cũ tới tư vấn dv"},
                {value: 4, label: "Khách hàng mới đến tư vấn"},
                {value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm"},
                {value: 6, label: "Khách hàng trả lại thuốc"},
                {value: 7, label: "Khách hàng tới hoàn phí"},
            ],
            selectedCustomerTypeValue: null,
            paraclinicalExamData: [],
            pageNumberSelectCustomer: 0,
            pageSizeSelectCustomer: 20,
            selectedStatusValue: 'null',
        }
    },

    async created() {
        this.getParaclinicalExamData();
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.getParaclinicalExamData();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        },
        '$store.state.isUpdateFile'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_FILE_SUCCESS', false);
            }
        },
    },

    methods: {
        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getParaclinicalExamData();
        },

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getParaclinicalExamData();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getParaclinicalExamData();
        },

        getParaclinicalExamData() {
            let typeCvt = this.type + 1;
            let payload = {
                endDate: this.dateRange.endDate,  //ngày tạo
                loyaltyCustomerId: this.loyaltyCustomerId,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDate: this.dateRange.startDate,  //ngày tạo
                // settingMedicalExaminationStepParentId  : this.parentId, //id trạng thái
                settingMedicalExaminationStepId: JSON.parse(this.selectedStatusValue),
                type: typeCvt,
                beautyMedicalRecordId: this.beautyMedicalRecordId, //Id Hồ sơ
            }
            this.paraclinicalExamData = [];

            this.$vs.loading();
            this.$crm.post('/beauty-subclinical/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.paraclinicalExamData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.beautyServiceName = el.beautyService ? el.beautyService.name : null;
                        el.beautyServicePackageName = el.beautyServicePackage ? el.beautyServicePackage.name : null;
                        el.hospitalAdmissionDateStr = el.hospitalAdmissionDate ? moment(el.hospitalAdmissionDate).format('DD/MM/YYYY') : null;
                        if (typeCvt === 2) el.beautySubclinicalNameDetails = el.beautySubclinicalDetails.length > 0 && el.beautySubclinicalDetails[0].beautyServicePackage ? el.beautySubclinicalDetails[0].beautyServicePackage.name : '';
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style>
/*.vs--single .vs__selected {*/
/*    overflow: hidden;*/
/*    white-space: nowrap;*/
/*    text-overflow: ellipsis;*/
/*}*/
</style>
